
    // Do not modify this file by hand!
    // Re-generate this file by running lit-localize

    import {html} from 'lit';
    import {str} from '@lit/localize';

    /* eslint-disable no-irregular-whitespace */
    /* eslint-disable @typescript-eslint/no-explicit-any */

    export const templates = {
      'backspaceKey': `⟵`,
'clearKey': `⎚ Temizle`,
'deleteKey': `Sil`,
'downKey': `↓ Aşağı`,
'endKey': `⤓ Bitiş`,
'enterKey': `Girin`,
'escapeKey': `⎋ Kaçış`,
'f10Key': `F10`,
'f11Key': `F11`,
'f12Key': `F12`,
'f13Key': `F13`,
'f14Key': `F14`,
'f15Key': `F15`,
'f16Key': `F16`,
'f17Key': `F17`,
'f18Key': `F18`,
'f19Key': `F19`,
'f1Key': `F1`,
'f2Key': `F2`,
'f3Key': `F3`,
'f4Key': `F4`,
'f5Key': `F5`,
'f6Key': `F6`,
'f7Key': `F7`,
'f8Key': `F8`,
'f9Key': `F9`,
'h64cd12550420f6f1': html`Oluşturmak 
          <code>LİSANS 
          </code> dosya 
        `,
'homeKey': `⤒ Ev`,
'keyCommand': `⌘ Komut/Kazan`,
'keyControl': `^ Kontrol`,
'keyOption': `⌥ Option/Alt`,
'keyShift': `⇧ Vardiya`,
'leftKey': `← Sol`,
'pagedownKey': `▼ Pagedown`,
'pageupKey': `▲ Pageup`,
'rightKey': `→ Sağ`,
's00065e45db8c0441': `Daha fazla ayrıntı için geliştirici araçlarına bakın`,
's001dd78415a91fa0': `Kaydırma çubuğu oluğu`,
's002fa7d1054ed082': `Kenarlık kutusu`,
's006f872a5b7f5279': `Sangro`,
's01b16a926920908b': `Kazakça`,
's01b56d233c6c5cac': `Bölümleme`,
's01d32b35baa3b676': `Yazar`,
's02106cc2ef0e7578': `Yeni pim.`,
's02ab1ea8e5100fc1': `Seçimi 'çift yönlü geçersiz kılma' olarak işaretleyin`,
's0312976fe9da5951': `Düğme`,
's03608a32f05eded2': `Çimdik yakınlaştırma`,
's036d35e03be98d22': `Matematik derinliği`,
's037b1dc850a89273': `Alternatif altında`,
's0396202b716732ec': `Seçimi vuruldu olarak işaretleyin`,
's03f49e598ffb11cc': `Lehçe`,
's0448f1059fa01720': `Keşfedilebilir dosyanızı kaydedin, paylaşın veya yazdırın. Başlık, dil veya lisans gibi bilgileri düzenleyin.`,
's0458872c43beadef': `Önce satır ekle`,
's04c939a414fdab21': `Tsonga`,
's050954cd4ae83304': `Kelime aralığı`,
's05e9759cfd99c48f': `Gerekçelendir`,
's063fa5a0a4903bf4': `Yana doğru, soldan sağa`,
's064339c229374050': `Kodlama`,
's06634274f19b0572': `Pin seçimi`,
's06743b24499f0035': `Çapa merkezi`,
's07808b0ca6da8fef': `Çitle Çevrili Web Sitesi`,
's07970793b21351fd': `Ruby temel konteyner`,
's079cf7850d9327f0': `Yazı Tipi`,
's07aa10850d9ddcc7': `Form`,
's07e6118e838b2e23': `Navigasyon`,
's0816468df86e4036': `Ayarları açar`,
's082869038c117fe5': `Portekizce (Brezilya)`,
's086e6c267ade2609': `Doygunluk`,
's08e12ade32ef8125': `Setswana`,
's08e6bd98452e6bb9': `Ses`,
's0978fb5ba3145996': `Liste ekleme (sırasız)`,
's09c3f1d21de14ae1': `Seçimi altı çizili olarak işaretleyin`,
's0a2d91c6720033e9': `Metin aralığı düzeltme`,
's0a3ddcba94027d95': `Nesne uyumu`,
's0a6cb8d42cdb0c4a': `Esperanto`,
's0a799f583098cadf': `Navigasyon ekleme`,
's0a7db790db1fc45c': `Seçimi açıklık olarak işaretleme`,
's0b1271f50a77dc73': `İçerik kutusu`,
's0b24d08ea349b455': `Ekleyebileceğiniz her şey. En başta listeler veya resimler gibi etkileşimli olmayan öğeler, daha sonra widget adı verilen etkileşimli öğeler bulunur. Arama çubuğuna tıklayarak yenilerini edinebilirsiniz.`,
's0bdca49248ba4820': `Kısayollar`,
's0befccf152b6c0a9': `Meta verilerden yönlendir`,
's0c11e479416c8421': `Tablo başlığı ekleme`,
's0c27336067c59611': `Kaydırma dolgusu`,
's0c4593d81f147042': `Başlangıç Noktası`,
's0c4b2e98d4ab7f5a': `Uygulama komutları`,
's0c883713b83616a8': `Etkin belgeyi kaydetme`,
's0ca5c0460199cba1': `Kısaltma`,
's0cf10c4f40588f8d': `Tablo Başlığı`,
's0d86afa3c6a1e28b': `Esnek yön`,
's0dad143dff0079fc': `Malayalam`,
's0db05bd7ba6fff96': `Keşfedilebilir belgeniz. Buraya metin yazabilir ve kopyala/yapıştır, düzenleme vb. yapabilirsiniz.`,
's0dc452999c129e15': `Canlı yeniden yüklemeyi etkinleştir`,
's0de0febab8a4beaf': `Bu paket okunurken hata oluştu`,
's0e44968489e076a8': `Çince`,
's0e4862e87c7d53ce': `Seçimi alıntı olarak işaretleyin`,
's0e6ea8870dbddab2': `Belge komutları`,
's0ee28503778e4c0c': `Son temel`,
's0ef01c03299bbb83': `Dekorasyon`,
's0f17f32919661cff': `Moğolca`,
's0f350bc4e538e3ea': `Kelimeler`,
's105a06836c40fcb4': `Seçilen öğelerin filtrelerini, rengini ve karışımını ayarlama`,
's106b274b5af798e5': `Cümleler`,
's1082e1649793dca9': `Seçimi tanımlanmış bir terim olarak işaretleyin`,
's10f3845975a0351e': `Meta Verileri Düzenle`,
's1125d159f7e64df5': `Ekran`,
's11326fd2590f4e5e': `Varsayılan`,
's1155ec07a221e739': `Kaydırma Çubuğu`,
's1173bf7a3e0b74c9': `Minimum (y)`,
's1177237a3e0e548c': `Minimum (x)`,
's1219d97b49650c05': `Görünürlük`,
's123bea44f38abccf': `Nesne ekle`,
's1245e2cb9f20197e': `Hizala`,
's12946ec1b850962c': `Sonrasına sütun ekle`,
's1351209ef74ee729': `Tüm sütunları kapsar`,
's13c60cb409e8cb6f': `Merkezi hizala`,
's13ebd619c8a06a6d': `Izgara otomatik satırları`,
's13ef8ca26ca8861b': `Kesim elemanı`,
's151bc2eea7a032a4': `-değişmemiş-`,
's153bc3c3aa39587b': `Masa Başı`,
's156647179b21d351': `Tablo gövdesi ekleme`,
's158b6ec6b1fffcb2': `Mola sonrası`,
's15d0c0657c1ee08c': `API Anahtarı`,
's1626a7e10a9f9dcc': `Seçimin yazı tipi ailesini ayarlar`,
's1637c7d1a30629e2': `Sınır Kutusu`,
's1641ab440bf4daa4': `Bu widget paketini güncelleyin`,
's166bd56d19670a72': `Yakınlaştır`,
's1696c76a23c0834e': `Gelişmiş: Paket yöneticisinde 0.x.x gibi sürümlere sahip paketleri göster`,
's16b9446e3a70e1f4': `Nitelikler`,
's16f205466761e583': `Optik yazı tipi boyutlandırması yok`,
's16f2f1c2c516d307': `Bir belge açın`,
's1749014f3f87fa6a': `Esneme`,
's17597a8bb4810524': `Lisans`,
's17bfaaa4e7528bc7': `Başkurt`,
's17fb3f4805f4f4b9': `Alanı kaldır`,
's181ef198cf83ec3a': `Bihari`,
's1857db526dc4dcdd': `Paket oluştur`,
's18d5c44aae3dc82a': `Düzenleme sırasında çevrimiçi`,
's1988d71ef8060edf': `Tablo satırı ekleme`,
's19abee1277c9bca2': `Samoalı`,
's19daf2f26c19543d': `Anahatlar`,
's1a1acc902e6668e0': `Gelişmiş metin biçimlendirmesini göster`,
's1a5230a71d9285c1': `Yakalama`,
's1aa1cb63ad44bc6f': `Sütun boşluğu`,
's1af8b67d1c85c811': `Aradaki boşluk`,
's1b4a36fce2456660': `Yazı Tipi Ailesi`,
's1c246045629b0016': `Seçimi silme olarak işaretleme`,
's1c3fc313a9184670': `Kamu Bağlantısı`,
's1c65f5004a07dcfa': `İskoç Galcesi`,
's1c690963f1e2df00': `Platforma özgü görünüm`,
's1ca22ce85e074da5': `Pragma`,
's1d10d2058d8ca8dd': `Kısa, rehberli bir tur ister misiniz?`,
's1d19244f549ec535': `Eğitim`,
's1d5c7b28e8b50d6d': `Ön lisans.`,
's1db591f5a54dbfd3': `İçerik Kutusu`,
's1dbb9f50e16c92a3': `Sınır yarıçapı`,
's1dfb744260fb3a01': `Çift Yönlü İzolasyon`,
's1e9c2c654732cc5f': `Byelorussian`,
's1eaccbf2d6af8ab5': `Bilgi`,
's1efbfc3937d565bd': `Arka plan`,
's1f2b49c1bca2035d': `Katalanca`,
's1f74bdf32b51a5fc': `Arka Plan Görüntüsü`,
's1f7698c061c208c9': `Açık`,
's1f8e59d0624842ff': `Kannada`,
's1feab14d837eadb0': `Guarani`,
's20deffeecf2699fb': `Korsikalı`,
's21d61916eb8d137d': `Masa Gövdesi`,
's21d723a1dbcd89c8': `Javanese`,
's21f8a2eaf5a70749': `Bir etiket ekleyin`,
's2206c42e5b835e6e': `Seçimi kısaltma olarak işaretleyin`,
's22a2348c46a912a0': `Bir bölüm ekleyin`,
's233ae776268cd44b': `İş Dünyası`,
's236ed7ba747099b0': `Yazı tipi ağırlığı`,
's2474e7fb1aec9f05': `Test`,
's2492f5fb1b05b45e': `Metin`,
's24949d7adbb5a098': `Araç Kutusu`,
's252a52330d32b900': `Metadata`,
's2540844a4bc4d9ba': `Atfedilmeyi gerektiriyor mu?`,
's255857544a9d5ec0': `Sıfırla`,
's255c77900f2b5e0f': `Renk düzeni`,
's256ab831a48c941c': `Seçimden tüm metin biçimlendirmesini kaldırır`,
's2591806d7b222591': `Değişiklikleri sıfırla`,
's25e1a07e454c2c11': `Izgara`,
's262abbaf1d05f009': `Yumuşak ışık`,
's266935f2447fcd98': `Sol Üstü`,
's268ecd1cef45a9a8': `Emin misin?`,
's2692bc028fed91f1': `⇪ Caps Lock`,
's27056379e0acfdb0': `Aydınlatmak`,
's27076e66c5d483ba': `Dikey hizalama`,
's2712dc5641a33226': `Paket kayıt defteri hesapları geliştiricilere yöneliktir ve bir veya daha fazla
          kayıt defterini yapılandırmanıza olanak tanır`,
's27cc88818cc46ff6': `Kararlı`,
's281d957112b10f12': `Belgenin HTML'sini doğrudan düzenleme`,
's28b6246ce616a548': `Tablo sütun grubu ekleme`,
's29a1c26521879b9f': `Ölçek küçültme`,
's29acfd2778e8c377': `Gelişmiş metin biçimlendirmesini gizle`,
's29b24c06315e9343': `Bir giriş ekleyin`,
's29eb103449472e3b': `Başlık ekleme (seviye 3)`,
's29ee7434494a0dfe': `Başlık ekleme (seviye 2)`,
's29f21c34494d614d': `Başlık ekleme (seviye 1)`,
's29fbfc3449557f72': `Başlık ekleme (seviye 6)`,
's29ff743449588131': `Başlık ekleme (seviye 5)`,
's2a031834495bcdb4': `Başlık ekleme (seviye 4)`,
's2a75c946ef4dcab7': `Çeşitli`,
's2b2ae20d26f78ac2': `Blok`,
's2b8f50c64be440f7': str`Seçiniz 
          ${0}... 
        `,
's2ba5f4d8f3bd7c57': `Sipariş`,
's2bad2d24def4aa0b': `Satır sonu (CJK dili)`,
's2ceb11be2290bb1b': `İptal`,
's2ced8e8fafb499f6': `Öğeyi sil`,
's2d986d31f8d67357': `Alan kümesi ekleme`,
's2d995a37cf5e4995': `Bir NoScript ekleyin`,
's2de969afacdaa7a6': `Şekil`,
's2df075aface0dab8': `Paylaş`,
's2e192b19ed15fcf6': `Sayfa`,
's2e39b99cf23606fa': `Seçilen öğelerin düzenini ayarlama`,
's2e4818861000b13f': `Düzen`,
's2e66bf8b833858f3': `Uigur`,
's2e969a451b4955d1': `Marathi`,
's2eda5288a65bca1d': `Taşma (y)`,
's2edd6688a65e21f0': `Taşma (x)`,
's2f0bcdffc92a786b': `Sağa kay`,
's2f2044f2431a32d5': `Başlık`,
's2f4d4bfbc466d91f': `Arnavutça`,
's2f8da2cb5f236588': `Paketinizin adı. Kapsamlı olmalıdır, örneğin \`@org/pkg\`. `,
's30cce87854901922': `Okul öncesi`,
's3124653c272f054c': `Sütun kuralı rengi`,
's314a4f7685c8e824': `Her zaman`,
's31c06e226322f065': `Yetimlerden kaçının`,
's323dcde72b850272': `Kamu erişimi`,
's32911e52ee8ac745': `Bir yuva yerleştirin`,
's337a1e9022a8d19f': `Tablo`,
's33c1450d2822bb0f': `Şekil başlığı ekleme`,
's33c18d5a4cbffa2a': `İrlandalı`,
's33f85f24c0f5f008': `Kaydet`,
's342b0cabfa672822': `Kullanıcının widget'ınızı bulmasına yardımcı olun`,
's3437e0d9899e7ae1': `WebWriter kullanımınız hakkında telemetri verileri gönderin.`,
's344ea8f4939cdc98': `Renk`,
's34dcda3b0f9d5a98': `URL'yi değiştir`,
's34f724979a124c50': `Seçili metnin arka plan rengini ayarlar`,
's355b21b89ce5d9c5': `Detaylar`,
's35ae5f4e0fa2777b': `Özel hizalama`,
's35aeaff1425bca9e': `WebWriter şu tür medyaları desteklemiyor `,
's35c3125c7750681e': `Blok Alıntı`,
's3643189d1abbb7f4': `Kod`,
's3649bacefe731bf6': `Araç Kutusunu Değiştir`,
's365280e16a8ea32d': `Seçimi kopyalama`,
's366991b9c9287765': `Doğru.`,
's36a194e38d653a26': `Veri Açıklaması`,
's36b3cefdcb897f15': `Perspektif`,
's372fae706048ce41': `Çift-tuhaf`,
's377e24af9628c37e': `Sıralı Liste`,
's37a8c35f6581da5f': `Çapa yok`,
's37fa3b9cd51c2dfd': `Seçimin yazı tipi boyutunu ayarlar`,
's380d17664bb69531': `Önce sütun ekle`,
's3815184eb09f0dcf': `İmleç`,
's382a2aa3984474dd': `Oluştur`,
's38980f98cb07ceb8': `Etkin belgeyi kopya olarak kaydetme`,
's3914cb410fca44d4': `İthalat`,
's3a179f6db2972384': `Yakut pozisyonu`,
's3a5ca02f282d247e': `Paylaş...`,
's3ae67088bbefba98': `Paketler`,
's3b0ab4b52326316f': `Işık`,
's3bdad99768e11911': `Keşfedilebilir`,
's3cb47df8290fa94c': `Bir seçenek ekleyin`,
's3cf89cb47fdde7e9': `Bağlantı`,
's3d09398e555ee5f9': `Gelişmiş Seçenekler`,
's3d249bb480032121': `Liste`,
's3d3efd1e19bdcfb4': `Tarih/Saat Ek Açıklaması`,
's3d6a732c792ccb9e': `Ruby Ek Açıklaması`,
's3d93f9ea0c5a13fa': `Resim`,
's3d9548e211b958ce': `Çakışmaları atla`,
's3e092e9d1ee2c5bb': `Klips`,
's3e78ddc9a48a608d': `Güzel`,
's3eb6d1e6e79ed7c4': `Hiçbir belge bulunamadı`,
's3eca5a034978754b': `Seçimi sil`,
's3f06e9abb6ebcb79': `Karakterler`,
's3f1e7a3f2b283d3b': `Marj`,
's3f299e83cbf52fba': `Zhuang`,
's3f43ef2eaa1ec486': `Gujarati`,
's3f7e097a9b2e6181': `Bir makale ekleyin`,
's3fd83566dd643d10': `Gösterge ekleme`,
's3fe72792941c18f9': `Alt metin`,
's3ffcdc5db5e7d0c5': `Ters`,
's40e3826b7f74a3b5': `Pan (sağda)`,
's40f07d7859284a44': `Baskın taban çizgisi`,
's4101ada154a1b958': `Orta`,
's410c465a5993f82d': `Satır Arası Fırsatı`,
's41322d19c928c603': `BİT`,
's417b90913e05bc17': `Önizleme`,
's418f2020fe996832': `Değişiklikleri onaylayın`,
's41c724f0698148e9': `Seçimi klavye kısayolu olarak işaretleme`,
's41f65a763f8e44ab': `Tablo başlığı grubu`,
's42721130228841b0': `İnme kutusu`,
's429bd646f1cf8bc6': `Grammar LLM hesapları, metindeki dilbilgisini düzeltmek için Grammar LLM API'sini kullanmanıza olanak tanır.`,
's429dd933ba95549b': `Bir adres ekleyin`,
's42e470ef1d707a28': `Otomatik Oynatma`,
's42ffdab1291fb3de': `Sonrasına satır ekle`,
's430831017f3f0499': `Eğiklik (y)`,
's430bd5017f42511c': `Eğiklik (x)`,
's433ba70286202ceb': `Hepsini kırın`,
's441b20a8a50e36b4': `Makedonca`,
's445b8acb9206db6e': `Atın ve iptal edin`,
's446a924922651ea0': `Metin vurgusu`,
's44cdba92713de38e': `Izgara alanı`,
's45518abd911471d0': `Hırvatça`,
's456a8d744313852a': `Etrafında boşluk`,
's4634541f5056a546': `Abhazca`,
's46d4abe6255cb9e1': `Kısayolu yeniden atama`,
's4730c232e7209c40': `İkisini de düzeltin`,
's474f0eec369d02a4': `Örnek Çıktı`,
's47a8f6dfb38b9701': `Telugu`,
's47e257ae643b5851': `Seçimi tarih/saat ek açıklaması olarak işaretleme`,
's47ebf3a8fb3b10c1': `Oryantasyon`,
's4802bb8eb52fbdeb': `Portal`,
's4802e47fe2e95134': `Opsiyon`,
's491d2919cd6ec3d9': `Hue`,
's497838412cb455f2': `Metin gölgesi`,
's4993444bfd3f3e5e': `Çöküş`,
's49ad24935b14e3df': `Quechua`,
's49c560aecfeb8c29': `Maske`,
's49dd67aed00029ef': `Matematik`,
's49e763aed00877a8': `Ana`,
's4a894f57eba1cf1e': `Klavye Kısayolu`,
's4ac1ad6ecd6bd810': `Misc. ed.`,
's4ad6e9d3c2365c98': `Sert ışık`,
's4b2c143acf931122': `Hat yüksekliği`,
's4b58c01e2578f5e4': `Efsane`,
's4bbff4e008690da1': `Sayfadan kaçının`,
's4c402ff5355fd310': `Çift Yönlü Geçersiz Kılma`,
's4caed5b7a7e5d89b': `İngilizce`,
's4cb38675a21b2c98': `Desteklenmeyen özellik türü '\${desc.type}' (JSON olarak işleniyor)`,
's4cc8391f172c0cdf': `Turu sonlandırın`,
's4d528b416ac8dee2': `Başlık grubu ekleme`,
's4d546f6c87128d5b': `Önce uzay`,
's4dcb9315f6527f9c': `Yeniden yüklemede çalıştır`,
's4e191bdb4700a6e9': `Aşırı kaydırma (x)`,
's4e1c7fdb470386ac': `Aşırı kaydırma (y)`,
's4e2562fe3990e621': `Bağlantı hatası`,
's4e361bf8eef3759a': `Kelime sonu`,
's4ea0f21fc2a338a1': `İlerleyin`,
's4eace13b3ed74187': `Yan Yorum`,
's4efee5b48a4593cb': `Döngü`,
's4f26e7cb7c0a8318': `Vektör Çizim`,
's4fd2e638aabb0bb3': `WebWriter birçok farklı kaynağın gömülmesini destekler. İçeriğe bir bağlantı
          yapıştırmanız yeterlidir:`,
's4fda04cbc245e18b': `Alfa`,
's4ffac3fb33a2ee9b': `Tayland`,
's5015a8fb33b98872': `İnce`,
's50489ffb1bde152e': `Yerleştirme`,
's5068560b8d39663d': `Tıklanabilir harita`,
's517acbf1f96324f9': `Ağırlık`,
's523eb9043213ff0d': `İtalik`,
's52777d434baeed9b': `Bir ilerleme göstergesi ekleyin`,
's52af5d7ac34c2163': `Masa Sırası`,
's52e0bdc3ee304436': `Bir sayaç yerleştirin`,
's531056f039febd39': `Bir seçim ekle`,
's536695196d0b6dc3': `Faeroese`,
's542fcefa0bbaed86': `Araç kutusunu açın veya kapatın (yalnızca dar ekranlarda, aksi takdirde araç kutusu her zaman yan tarafta görünür).`,
's5432ad3c84273229': `Şekil`,
's543906d1db8b2283': `Düzenle `,
's543c237e8c895ce8': `Bislama`,
's545ee1f373f249cf': `Kamboçyalı`,
's54897f2764b0e4d0': `Bu widget paketini yükleyin`,
's54cbfaf2a8da7818': `Peştuca`,
's550839f3e4e205bb': `Seçimi çok önemli olarak işaretleyin`,
's55905c735052d295': `Tematik Mola`,
's5590dbf7e425789d': `Etiket`,
's5623aa2f83b05c76': `Tibetçe`,
's564d1648b1ceee9f': `Güncel`,
's565cd5ffb0158c46': `Bölgeden kaçının`,
's571a4f19e2f140c7': `Tava (x)`,
's571db319e2f4208a': `Pan (y)`,
's575e795c45e2d97e': `Geri dön`,
's5787c6d5b3b5541a': `Klip yolu`,
's579c69f419b6caef': `Pürüzsüz`,
's587ac858dd80f6fa': `Alt simge`,
's58bec0ecd4f3ccd4': `Katı`,
's59404f5593c32fdc': `Yazı tipi karakter aralığı`,
's5941292bb77281ab': `Norveççe Bokmål`,
's599dcd2472c75c19': `Paragraf`,
's59b20e8af32606ed': `Afar`,
's5a1a0898baf20675': `Seçimi bir veri ek açıklamasıyla işaretleyin`,
's5a356677b61a6b7e': `Moldavya`,
's5b474b5c0ac0c7c4': `Tablo sütun grubu`,
's5b517ac216f9ee62': `Yana doğru`,
's5b8cc9bb61ddce15': `Bir paragraf ekleyin`,
's5bba2ac2e53bd1fd': `Kırgız`,
's5be80ad6b8301710': `Satır içi başlangıç`,
's5c1ecf88259b79f9': `Sunum`,
's5c2a1a52c0389c30': `Mühendislik`,
's5c63af7695445fcf': `Metin Stili`,
's5d18ca4c3111be6f': `Tablo başlığı ekleme`,
's5d87c1e588f48d90': `Uygulama`,
's5d929ff1619ac0c9': `Arama`,
's5da52af9b083c29a': `Model`,
's5dc77784260a7236': `otomatik`,
's5e27738a2e8eb763': `Oturum aç`,
's5e2cba97c0d971bd': `Paketleri yeniden yükle`,
's5e53415a6d5719ad': `Sosyal bilimler`,
's5e6a7a0c30d2a270': `Çakışmaları atla (otomatik)`,
's5e9e8e4d21bafedc': `Gıda üretimi`,
's5ed03bb1f3a15949': `Resim`,
's5f43af3669b1e098': `Kaynak`,
's5feaf7fd7ee567c8': `Ara kelime`,
's600fd23c9ce971e8': `Etkin belgeyi yazdırma`,
's602bbd28dae2c60f': `Kendi kendine başlangıç`,
's60ff598dfcf2c773': `Sağ Altında`,
's61053f0e3ebbd272': `normal`,
's613c6ff83883c04f': `Tablo Sütunu`,
's6196153c4b0c1ea0': `Kurulum`,
's61c017f6d5c303af': `Frizce`,
's61ded17ca3f48c82': `Alt çizgi ofseti`,
's61eacb19db252f5e': `URL`,
's621ad19d35ba7742': `Kopya seçimi`,
's624e31cd4f1b89d4': `Düzgün kaydırma`,
's626daf42b1ab7df7': `Sola hizala`,
's6280bf993915c57a': `Kaydırma marjı`,
's62b857f5b6693742': `Inupiak`,
's63d894b1ddb06289': `Açıklama`,
's63dfc5b1c1c27849': `Yidiş`,
's63e03c70f67ebf9c': `Bağlam`,
's63e71d20d1eaca93': `Alman`,
's640bc7710d0143ce': `Etkin belgedeki son geri alınmış değişikliği yeniden yap`,
's64dc1fc7e3db45c9': `Yeni bir belge oluşturun`,
's65ac276544ba33cd': `SVG dosyası`,
's66765c420ee578e4': `Eşit alan`,
's669b18c6d2d9c95b': `Hiçbiri`,
's6747dbf4ad6063ba': `Kendi kendine son`,
's6787497df07fa97e': `Duraklar üzerinde kaydırma yapabilir`,
's67c2b60a506a09e4': `İkincil eğitim.`,
's680bd4d926cd5a84': `3D'yi Koru`,
's6827930ef1aeaf99': `Temel URL`,
's684a16f3c711394d': `Aşırı Sağ`,
's687e27f036a71b32': `İzole etmek`,
's68b87d7b61052dc3': `Masa sırası`,
's68e0e3a2bab7ce3e': `Kaçının`,
's690da6b432987c6f': `Geçerli belgedeki değişiklikleri otomatik olarak yedekleyin. WebWriter yeniden yüklendiğinde değişiklikler geri yüklenir.`,
's69311c4e25074fb3': `Lise`,
's697400b541fbc3cd': `Altında`,
's6988ab5d47593a26': `WebWriter'ın en son sürümüne sahipsiniz.`,
's69a49786a8009f43': `Paketleri bulun...`,
's69b12144dbb6544d': `Laothian`,
's69d88ef4b2618980': `Kapak`,
's69fbbdb8ad2a084a': `Karanlık`,
's6a31eff1ec4f71ad': `Arka yüzü gizle (3D)`,
's6ac62e1c8c66f3bb': `Kompakt süpercr.`,
's6b585ba37cdb8260': `Miras`,
's6b61f8abf89586be': `İbranice`,
's6bd7a02fdf93e653': `İçeriği hizalayın`,
's6cfc66b824ea05ba': `Keskin kenarlar`,
's6d02dc19e21eb49c': `Üst`,
's6d1df519e235a6cf': `Twi`,
's6d60d595cb5070da': `Vietnamca`,
's6d8b3b8047ed378d': `Karışım modunu karıştır`,
's6d8c02aee480af7a': `Menü`,
's6dadeaaee49d6d18': `Meta`,
's6dfb502188a8c7c2': `Stil ekleme`,
's6e288a119281f4c2': `Metin oluşturma`,
's6e4c20c6debcd5ca': `Özel gerekçelendirme`,
's6f84199e62584905': `Önceden Biçimlendirilmiş Metin`,
's6fb3053e7244d326': `Diğer alanlar`,
's70178e04a3b691b6': `Ayarları Aç`,
's7031ca562378bde6': `Geometrik hassasiyet`,
's7060970b5ed20a58': `Etkileşim`,
's7136449045eff28c': `Tamilce`,
's71940c32987f675f': `WebWriter Bulut`,
's71a0549fd71219c9': `Kararsız paketleri göster`,
's71dec51005acc1e4': `Sıra yoğun`,
's72f2a02e2a5a4ee3': `Medya`,
's730182ad28374cda': `Nesne`,
's731678e227a20559': `Bu Cihaz`,
's736904f276fbd441': `Doğa bilimleri`,
's739544d0c858c633': str`Ya da bırak 
          ${0} Burada 
        `,
's73cb20c838e761e1': `Kesim seçimi`,
's7417792bbe720149': `Yeniden Yap`,
's741fae02b3dd24f3': `Pikselli`,
's743f778233e42a3f': `Bir kenara ekleyin`,
's744d993d03f29851': `Ekran`,
's748c0074eff45884': `Manipülasyon`,
's74aa0039a87141e2': `Ellipsis`,
's74b9781bacfcc87c': `Punjabi`,
's74cd20a7aece9b91': `Doldurma kutusu`,
's75109f5307578a61': `WebWriter'a Hoş Geldiniz`,
's75a27f43413e02c5': `Fransızca`,
's75d83fc3f0cfab40': `Başlık`,
's762e5704cc84089d': `Seçilen öğelerin diğer stil seçeneklerini ayarlama`,
's77318393dfdb0775': `Satırı kaldır`,
's77e594ddcc10c774': `Ticari kullanıma izin veriliyor mu?`,
's782eac2b3e80323d': `Seçimi vurgulanmış olarak işaretleyin`,
's782f286a79cca35d': `Göreceli`,
's78673a3539cb1915': `Sol üst`,
's78789724e789221c': `Boyut`,
's789ff24c8f03f1a4': `Harf aralığı`,
's7995733bf97c01cc': `Sırp-Hırvatça`,
's7a99528e7b64635a': `Oksitanca`,
's7aaf0c06e69600f1': `ile hata `,
's7ae49e142487766c': `Topluluk erişimi`,
's7af555180b30a947': `Geliştirici araçlarını açın`,
's7b4ba250601b8667': `Şablon ekleme`,
's7b560d8693ed8f42': `Dik`,
's7b9994904c4f5b54': `Tacikçe`,
's7bdf0fd5b014d36c': `Güçlü Önem`,
's7beb1e77e82363eb': `Etkin belgedeki son değişikliği geri alma`,
's7c61118554a0ec36': `Maksimum (x)`,
's7c95876637f6a9d7': `Filtre`,
's7cb4e55c59663b1c': `Şirket`,
's7cfe12cd14df9950': `Çıkış yapın`,
's7d27db3c9639c6dd': `Alternatif`,
's7d8103f6f06f83d6': `Dolgu`,
's7d864465dddbb50d': `Yeniden boyutlandırmaya izin ver`,
's7de0e28d6c309a4e': `Dokunma eylemlerine izin ver`,
's7dea785045c3cc74': `Yeni tuş kombinasyonuna basın...`,
's7e0b179d4d1414eb': `Bağlantı girin`,
's7e6570f2f1ae320f': `Yazı karakterlerini sentezleme`,
's7ecb1f29332293e5': `Hizalama temel çizgisi`,
's7ed13ccddb1bf3c3': `Kaplama`,
's7edbe0b213199995': `Lisans`,
's7ede1c55e35ce9d6': `Simülasyon`,
's7f09197a4814079b': `Seçilen öğeler için etkileşim seçeneklerini ayarlama`,
's7f326a142e856656': `Stil`,
's7fcb35d23be1e643': `Saha Seti`,
's80570196a9ce6d11': `Telemetriyi etkinleştir`,
's806f84eb0ace116e': `Neyi seçtiğinizi görün ve değiştirin. Kopyalayın, kesin, yapıştırın, sabitleyin veya düzen değişiklikleri yapın. Seçiminize bağlı olarak farklı seçenekler sunar, örneğin metin için biçimlendirme.`,
's80a42b81c52d4d8f': `Caret rengi`,
's80b71fc6f43c5ce1': `Gevşek`,
's812cbda653daaeba': `Bu özellik henüz uygulanmadı`,
's81c3d8809658b951': `Kashmiri`,
's81cf65c5a46dea08': `Kinyarwanda`,
's81ecf2d4386b8e84': `Devam et`,
's8247d32213e35f24': `Bir ana sayfa ekleyin`,
's82665b2ffabc9c0a': `Web sitesi`,
's828b1ecea8715884': `Tava (solda)`,
's833bd0422a7ef95d': `Sekme boyutu`,
's83420ad7b6a14db5': `Geliştirici Araçlarını Değiştir`,
's83c15613b6f6f3c8': `Sadece çevrimiçi`,
's83cd32b685ccc9b7': `Kontroller`,
's83f26d02dd7aa681': `Görünür`,
's840fa49e8989c028': `Konum/Şekil`,
's844a76d1843ceb3c': `Varsayılana sıfırla`,
's84e4e8ae645b82ac': `Sağ üst (y)`,
's84e9c7f8785ca60b': `Form ekleme`,
's8517ae4da104b004': `Tablo Sütun Grubu`,
's85186a61e0d55bac': `Video`,
's851a7deea5984646': `Creative Commons OER olarak lisanslansın mı?`,
's85f9aa6d3ea0e421': `Tablo altbilgi grubu`,
's864b0e6270e97246': `Seçimi yan yorum olarak işaretleyin`,
's8670e5ad3bf0dcf8': `Farklı Kaydet`,
's8688d74dd3716d6e': `Komutlar için klavye kısayolları`,
's86ca34c5287a2f38': `Wolof`,
's86f820d8007d0de4': `Şekil marjı`,
's87cefc710b3567fb': `Konteyner`,
's88676f992b2965db': `Hücre içeriğini esnetme`,
's886897f2fd4edb99': `Gizli`,
's886c5db2a5579873': `Konsept`,
's888c71e8fcb916d3': `Otomatik Kaydetme`,
's88a62d29529948fb': `Tablo ekleme`,
's89950d86c8004d4b': `Çakışmaları atlama`,
's89bca7498f20e041': `Arka Plan Klibi`,
's8a28bad9290d4761': `Oromo`,
's8a29cb39a42f83f3': `Önce ara verin`,
's8a4ff2bd9c13498c': `Kayıt`,
's8a6585c48ea104e9': `Boş hücreleri gizle`,
's8a9eb438abac7c6a': `Etiketler`,
's8b0432eecbd8b034': `Güncelleme`,
's8b7580c35e2aef87': `Sol üst (y)`,
's8bc4affa761aa8a2': `Resim ekleme`,
's8c7f51cb067644c7': `Veri Listesi`,
's8d342ecaa9e75b9b': `İlişki`,
's8d797888455f4147': `Mola alanları`,
's8d83386457e91813': `Değişikliklerinizi geri alın/yineleyin veya öğrencinin bakış açısından önizleme yapın.`,
's8d8643013a7754d1': `Metin hizalama`,
's8df30fe2a50d3479': `Satır sonu fırsatı ekleme`,
's8e715248c3a78446': `Seçimi kesin`,
's8f29e48d6b9a1aa8': `Tablo başlığı satırı ekleme`,
's8f4be9f086eb530f': `Geri al`,
's8f533296a536965e': `Farklı kaydet...`,
's8fad58c831ecf017': `Ruby metin kabı`,
's8ffe7abcbed8eb43': `Dikey, soldan sağa`,
's90105521fcc40453': `WebWriter Cloud hesapları, belgeleri çevrimiçi olarak saklamanıza ve
          öğrencilerinizle paylaşmanıza olanak tanır. Buraya bir hesap ekleyin ve bu hesap belgeleri
          kaydetmek, yüklemek, paylaşmak ve açmak için bir konum olarak kullanılabilir olacaktır.`,
's9095f01a80a91594': `Süper`,
's90f0fbc12e1e2b2f': `Yazı tipi paleti`,
's90f7c1cf501ea0a7': `Renk atlatma`,
's91093e0b087911ba': `Vurgu pozisyonu`,
's919e1724f589c9b1': `Yuva`,
's91c5ed7769d00b65': `Yerleştirme ekle`,
's9219acd5bef6269e': `Sol altında`,
's92548405912d46bf': `Kaydırma ek hizalama (y)`,
's9258280591309342': `Kaydırma ek hizalama (x)`,
's927d796559f49439': `Arka Plan Kökeni`,
's92b177e579ef7b97': `Vurgu`,
's92f846b9be2e8e8d': `Seçimi italik olarak işaretleme`,
's93566b84230af4f5': `Resim ekleme`,
's936aa0b239679585': `Tematik bir ara ekleme (genellikle yatay bir çizgi olarak görüntülenir)`,
's9370dc6afa716b57': `Sınır`,
's93f083e654a45715': `Breton`,
's94653c76b2d86a04': `Tanımlanmış Terim`,
's9485af2e7cd9418f': `İlkokul`,
's94d2eee44b292567': `Gelişmiş seçenekleri aç / kapat`,
's94d61907ee22a8c1': `Korece`,
's94eb1effbbb6498b': `Taşma`,
's951aa3a6439f1271': `Liste işaretleyici`,
's9565553d163fc92a': `Senaryo`,
's957787fc6b7ea5c0': `Tava (yukarı)`,
's95d56e58f816d211': `Hollandaca`,
's95d8e41a64635c7c': `Beyaz alan`,
's95de7e1eff6c053e': `Yatay, yukarıdan aşağıya`,
's960d3a90ac199368': `Rhaeto-Rumence`,
's96532132a29dd542': `Ses ekle`,
's96a045dcade75ad0': `Sütun yoğunluğu`,
's9781a5bb3fcb26a3': `Önce bir şirket seçin`,
's978522fbc9577a7e': `Somali`,
's97881699a2b21d5b': `Sıra boşluğu`,
's97aa76056a81bd36': `Metrikler`,
's986facb3ecc9602c': `Yana doğru, sağdan sola`,
's987abd19fac8cf55': `Alt`,
's9896529e5cb20558': `Harici Dosya`,
's98977a87d1b93941': `Bilgileri, stilleri ve komut dosyalarını sıfırlayın`,
's990d0e0fa2ab00b5': `Galiçyaca`,
's99229574e5692f19': `Grönlandca`,
's99a990f3841ad283': `Dosyalar `,
's99b38e000175cc84': `Üstü çizili`,
's99f110d27e30b289': `Başlık`,
's9ab10fbf4c7a7322': `Altı çizili konum`,
's9abadcc828884d7b': `Metin Alanı`,
's9b7cd8860c8fc922': str`
          ${0}
          üzerine yazılacaktır. Emin misiniz? 
        `,
's9c11f2d9335d8bd1': `Oriya`,
's9c356016f81585f6': `Arka Plan Rengi`,
's9ca757effd747da9': `Urduca`,
's9caf10388ab3562f': `Tablo sütunu`,
's9cf68f87b8e6122f': `Azerice`,
's9d167ef77aed79b6': `Katman`,
's9d2d00982edafabb': `Türkçe`,
's9d430adc5be110e9': `Ters Sıra`,
's9d54829be67943d3': `Interlingue`,
's9d54869be6794a9f': `Interlingua`,
's9d668a34af4128ff': `Silme`,
's9df571714a1efb44': `Bu keşfedilebilirin otomatik kaydedilmiş bir sürümü mevcuttur. Yükleyelim mi?`,
's9e28faa598332e2b': `Video ekle`,
's9e3dbb678150edd4': `Yazı tipi ailesini ayarlama`,
's9e40e59654c8ad67': `Sütun`,
's9e85800d3700e31c': `Parça`,
's9e8d3665edde89a6': `Nauru`,
's9eefe6e57e4e1661': `Yazı tipi varyantı`,
's9f1ecdb3061d9cbc': `Alanları koruyun`,
's9faf26107ed49fb9': `Tablo hücresi ekleme`,
's9fbe26cfd7845469': `Hausa dili`,
's9fc686f7bbd941e2': `Geçiş`,
's9ff3121d30f88d52': `Normal`,
's9ffe1bbe64712bf1': `Tuval`,
'sa00df4e39c72d3b4': str`
          ${0} desteklenmiyor 
        `,
'sa013e119fec906fb': `Sıra`,
'sa01e7bf33563ef72': `Arka Plan Eki`,
'sa126cf8c627cec1e': `Görüntü oluşturma`,
'sa13f72278add7513': `Sağ altta`,
'sa1647e3b36ec08d7': `Dik olarak birleştirin`,
'sa172190ea21f9b1c': `Ayarlara erişin, bir keşfedilebilir açın veya yeni bir tane oluşturun.`,
'sa1c6c459b9b5115c': `Mutlak`,
'sa2cba871f6cdd99f': `Assamca`,
'sa2eff4dad1c119f1': `Izgara şablonu`,
'sa30c12014e955946': `Rusça`,
'sa30f1981fd1cd441': `Yazı tipi boyutu`,
'sa311a24c1471a974': `Belge`,
'sa352d168b262aa06': `Altbilgi ekleme`,
'sa37fee6a52d18063': `Belgeyi sil`,
'sa39c7ac1d37f3bce': `Seçimi 'çift yönlü izole' olarak işaretleyin`,
'sa3b4c01623211544': `Kuvvet`,
'sa40fd43756fa8913': `Farsça`,
'sa417644bef21a9aa': `İsimsiz Tema`,
'sa43800e28be1bdbc': `Dekorasyon rengi`,
'sa477cb1825dceb3b': `Sudanlı`,
'sa492a51a707930fa': `Blok alıntı ekleme`,
'sa4e5b39489ecf31a': `Xhosa`,
'sa4f137f8619093a5': `Alttaki başlık`,
'sa50d3c35533f1d99': `Tüm alanlar`,
'sa53c5cb03a8fda50': `Seçimi palette bir snippet olarak sabitleme`,
'sa557ae6bee9148a6': `İlerleme`,
'sa589e1df65dde0ec': `Seçilen öğelerin boyutunu, dolgusunu ve kenar boşluklarını ayarlama`,
'sa5c371b4bb75e590': `Sol`,
'sa5c80e623459ffe4': `Başlık ekleme`,
'sa5df1bcdba46c3fb': `Şekil Başlığı`,
'sa602e3fd3f2d98fd': `Animasyon`,
'sa644d580d8a11e60': `Yakut hizalama`,
'sa645d315510dc09e': `Diskten yol seçin`,
'sa65d4ad99f1d8c06': `Metin arka planını ayarlama`,
'sa6607436f60ccc1a': `Estonca`,
'sa6f8d27bca557059': `Meta/bağlantı/stil öğelerini bu öğenin içine yukarı/aşağı taşı`,
'sa757645ad842da97': `Molaları koruyun`,
'sa75b95980cd80e78': `Editör`,
'sa7698b3d20a6d1ec': `Kaydırma`,
'sa778acc33947c7b8': `Turu bitirin`,
'sa78a67272a4a6f95': `Matematik Formülü`,
'sa79167651dce1e80': `Alternatif metin`,
'sa7af797a46c7d09a': `Tablo Altbilgisi`,
'sa7dbe35b758c138d': `Tuval ekleme`,
'sa7dc6b8ef3f595dc': `Bir kaynak ekleyin`,
'sa8279f8211b3950d': `Molaları ve boşlukları koruyun`,
'sa8b55cab62e439b5': `Sütunu kaldır`,
'sa8bbe0197d31b423': `Kısa Açıklama`,
'sa9ff3b762365abe6': `Dönüşüm orijini (z)`,
'saa02e3762368ff35': `Dönüşüm orijini (y)`,
'saa065776236bfa28': `Dönüşüm orijini (x)`,
'saa33768e03c45fc8': `Dosya Boyutu`,
'saaad98061a20ac39': `Bir matematik formülü ekleyin`,
'saab875d8cfcfe712': `Tema`,
'saad4380b9cc6cefd': `Alternatif üzerinde`,
'saaec15c97a9e4245': `Sütun Tersi`,
'sab0c57df694a0a09': `Trim başlangıcı`,
'sab4d9283896d9422': `Snap çözünürlük pikselleri`,
'sab55faae8e165407': `Dolgu&lt;br&gt; boşluk gibi`,
'sab5e7d2a069a2951': `Mesleki sertifika.`,
'sab726d2db7e6b93d': `Kirundi`,
'sac687b8649989de8': `Sağa hizala`,
'sac895c732f350ac5': `Karanlık`,
'saced41ddda8b2354': `Esnek temel`,
'sad190f86451081c0': `Nepalce`,
'sad6be321164d08c8': `Kompakt matematik`,
'sadd352cc7f6f2307': `Bir kenara`,
'sae098810f946ca7c': `Tagalogca`,
'sae185e6af80ec81e': `İsveç`,
'sae1c7f13b7c0c47f': `Başlangıç`,
'sae76e25497dcee58': `Recto`,
'sae9c790b88be7eb9': `Maori`,
'sae9d739068eee2c5': `Tatar`,
'saf312eaeec77a802': `Bir açıklama listesi ekleyin (sözlük, terim listesi)`,
'saf3da7c95cb17260': `Seçimi bir üst simge olarak işaretleyin`,
'saf440a0a592f2835': `Güncelleme`,
'saf9e5134ba1a7d30': `Kaydırmalı çıtçıt`,
'safc6f203342d09e2': `Etkin belge için önizlemeyi değiştirir`,
'sb0a7e3adf4a125ee': `Sağ üst`,
'sb0a974028c99ca6d': `Uyarlamalara izin verelim mi?`,
'sb0d4f0f7993cf085': `Yazı tipi boyutunu ayarlama`,
'sb0f3327210fe18fc': `Sütunlar`,
'sb0f93c1c60c0249a': `Yakut tabanı`,
'sb1494c08c8c720d1': `Metin rengini ayarlama`,
'sb19611adbc88f711': `Gelişmiş: Kaynak düzenleme komutlarını gösterin, örneğin belgenin HTML'sini göstermek veya özel stiller ve komut dosyaları eklemek için.`,
'sb206d700d26b14ff': `Altı çizili`,
'sb233557012dcb328': `Aşağı inin`,
'sb26035b596566abf': `İsimsiz`,
'sb2cda80610c8d6ea': `Tüm uzay`,
'sb2dc787b0983ebc6': `Litvanyalı`,
'sb31cdff08b1c5a50': `Sindhi`,
'sb38d497d992ab4a4': `Merkez`,
'sb3ba3276ae93627c': `Önceden biçimlendirilmiş bir metin bloğu ekleme`,
'sb430f5b4824de0d3': `Bir düzen seçin`,
'sb43db07b24da018a': `Amharca`,
'sb45f9fb4dba6e71a': `Ayarlanmamış`,
'sb4e003a459464d85': `Kürtçe`,
'sb4f0310e6787d098': `Özbekçe`,
'sb4f1dffbb6be6302': `Temiz`,
'sb51270e19988f9bd': `Bölge`,
'sb59d621e3c93cc27': `Paylaşılan hücre sınırları`,
'sb5e9e1776242b028': `Etkileşimler`,
'sb60bc1250aad44c1': `Açıklık`,
'sb60dd9d23d31ee66': `Doktora`,
'sb6103872073d369e': `Ayrıntıları ekleyin`,
'sb616811735bfbafd': `Tablo hücresi`,
'sb628960829e223bb': `Tüm çakışmaları atla`,
'sb6434faf698b02a2': `Shona`,
'sb657bfe93338dc8b': `Volapuk`,
'sb66beca1e766dcb3': `Uygula ve içe aktar`,
'sb66e2181a7b5738a': `Telemetri özelliğini etkinleştirerek, veri toplama ve saklama işlemlerine izin vermiş olursunuz.`,
'sb67e0e7c0869f982': `Farklar`,
'sb68e83cda6c85af8': `Tablo başlığı`,
'sb6b268120592dc53': `Hintçe`,
'sb6ca0a8bb3caae69': `Dekorasyon kalınlığı`,
'sb70c17f7899f9b01': `Latince`,
'sb71941f552f3504d': `Özel değer ayarlama`,
'sb740eab4afd5a710': `Izgara otomatik akışı`,
'sb741b6e0ca589122': `Katmanı geri döndür`,
'sb7c77d0415de05cf': `Testleri çalıştırın`,
'sb7fb7568f6883ab8': `Etkin belgeyi paylaşma`,
'sb85774dc5d18ff0f': `Onaylayın`,
'sb85b1e36579852a6': `Geçersiz e-posta veya şifre`,
'sb884fa76bfc55429': `Arapça`,
'sb8a3d4df7d1c5e6b': `Denge`,
'sb8f610a0e8df91fc': `Luminosity`,
'sb8f855b49234b81b': `Başvurmak`,
'sb905da066c10182c': `Artı daha koyu`,
'sb940ade1bd81be7e': `Sol Altında`,
'sb9e9a7dd45966756': `Seçimi kalın olarak işaretleyin`,
'sba509fd8ed61d1d5': `Kaydedilmemiş Dosya`,
'sba64d8954d027206': `Opaklık`,
'sba88d90cd6c751b3': `Sütun kuralı`,
'sbaf0a7c417e388af': `Sağlık`,
'sbb15d427ee1aa676': `Tigrinya`,
'sbb34f2e3aa40af4e': `Tonga`,
'sbb55f9f2d69fd327': `Arka plan filtresi`,
'sbb85a407d730e13d': `Bir arama ekleyin`,
'sbb86c6c96f598bb8': `Karışık`,
'sbba0156f795d8c07': `Seçimi düzenle`,
'sbba865d4b437944f': `Öznitelik`,
'sbbe639e3a3ed95d1': `NoScript`,
'sbc5bb5bb74d141b9': `Kaldırma`,
'sbc5f2a81604baf9b': `Başlık 6`,
'sbc5f2b81604bb14e': `Başlık 5`,
'sbc5f2c81604bb301': `Başlık 4`,
'sbc5f2d81604bb4b4': `Başlık 3`,
'sbc5f2e81604bb667': `Başlık 2`,
'sbc6953a36ced943f': `GİZLİLİK POLİTİKASI`,
'sbd181cd54b8402a4': `Seçimi düzenleyin`,
'sbd35ee879d9cf770': `Yakut metni`,
'sbd40f40cbadd38d5': `Bu widget paketini kaldırın`,
'sbd72dc858de95ce8': `Birmanya`,
'sbe3c60c65f129daa': `Beşeri Bilimler`,
'sbe4a7c8f231739b3': `veya yapıştır/bırak/dosya seç`,
'sbe90de083557ef3e': `Swahili`,
'sbefb6064cba01844': `Satır sonu ekleme`,
'sbf00e1ee999ea94e': `Bir komut dosyası ekleyin`,
'sbf519920c2017d67': `Asılı`,
'sbfa01f189a68d3e9': `Esnek büyüme`,
'sbff54e740c4086eb': `Bilinmeyen paketleri göster`,
'sbfff51feacf30196': `Sanskritçe`,
'sc0ceaa9843510f67': `Türkmen`,
'sc1611c0558728a2a': `Pozisyon`,
'sc1a155cc25899250': `Tablo satır grubu`,
'sc1aa1f6051b7102a': `Romence`,
'sc1edebeaef92b7bd': `Sabit tablo düzeni`,
'sc1fff4f356dfb2fb': `Dönüşüm`,
'sc24bda3c061fddf8': `Tıklanabilir alan`,
'sc252a4e091763606': `Tablo altbilgisi ekleme`,
'sc2536e077514accc': `Kaydırma`,
'sc275dd00036d16cb': `Alıntılar karakter`,
'sc28864200d2a3799': `QR Kodunu görüntü olarak kopyalama`,
'sc2a24a9dd41a9503': `Dekorasyon hattı`,
'sc2b734cca2fa643b': `Pan (aşağı)`,
'sc2e2a0dbf03723b7': `Gelişmiş: Paket yöneticisinde bilinmeyen kaynaklardan gelen paketleri göster (Uyarı: Güvenli olmayabilir)`,
'sc3998b77d72c2932': `Bir web sitesi ekleyin (satır içi çerçeve olarak)`,
'sc3ac225273c8316b': `Genel`,
'sc3cfee84dbbf36ae': `Yerel Dosya`,
'sc3f09a9b6fa4fbed': `İçeride`,
'sc43767deea72e9f3': `Açıklama Listesi`,
'sc462bbdd36bcba6b': `Referans kutusu`,
'sc4ee3e4ee994dafd': `Ukrayna`,
'sc50d09edf9325339': `Diyalog`,
'sc52b67794c06a0d3': `Perspektif orijini (y)`,
'sc52e8b794c0913d6': `Perspektif orijini (x)`,
'sc53de149fcaad713': `Karakterler arası`,
'sc546f489f9c0cced': `Etkin belge için test modunu değiştirir`,
'sc5bcf50d1b578d9f': `Yazı tipi özelliği ayarları`,
'sc5cb39478b9b7625': `Seçimi bir alt simge olarak işaretleyin`,
'sc6415b50ff928294': `Liste öğesi`,
'sc650ff15b20fe9d3': `Döndür (z)`,
'sc6578b15b2154365': `Döndür (x)`,
'sc65aff15b2183e58': `Döndür (y)`,
'sc6da0f4a7e4d710e': `Yazı tipi dili geçersiz kılma`,
'sc74e3567875ce255': `Hem widget'ınızın etiketi hem de NPM paketinizin adı`,
'sc7eb080b96e244df': `Malay`,
'sc8ac7ef92b95df3f': `Taşı (x)`,
'sc8af536e2084ade0': `Palet`,
'sc8b022f92b992bc2': `Hareket (y)`,
'sc8b39af92b9c2d81': `Hareket (z)`,
'sc8d2c7f6c33a2b32': `Seçilen öğelerin metin stilini (hizalama, girinti, aralık, vb.) ayarlama`,
'sc8fa0e3de389ef1c': `Yazı tipi boyutu ayarı`,
'sc9474bf7a0668d73': `Özet`,
'sc94e314312a8900c': `Çek Cumhuriyeti`,
'sc980855a000b76ea': `Alt`,
'sc98b103772de63f4': `Fince`,
'sca7cfe2bef51b2a5': `Kök`,
'sca7fed2bef53cb99': `Rol`,
'scabe6ecee5e01fd2': `Maltaca`,
'scace301a88231cce': `Gömmek`,
'scbc55f622ec078c1': `Kutuyu görüntüle`,
'scbe537fc38ff4c13': `Izgara otomatik sütunları`,
'scc1db59d292cbc4c': `Bölüm`,
'scc56b218a2689c42': `Ermenice`,
'scc5ba32e0de06744': `Sesotho`,
'scd15088c39fe9edf': `Dolgu Kutusu`,
'scd9cedeb5ece3adb': `Tireleme`,
'scdf536b65be39ec5': ` Oluştur/ithal et`,
'sce8a4e3f7c98482d': `Siswati`,
'scec2be75ee985f6c': `İdeografik`,
'sceecdd0bb404bc17': `Bir seçenek grubu ekleme`,
'scf00d48fd5953a03': `Yunan`,
'scf932840a69dbb7c': `Portekizce`,
'scf932a8577057752': `Altbilgi`,
'scf95dcb12a950a5c': `Aymara`,
'scfcb70f2a15eaf14': `Sağ alt`,
'sd01178c54f648118': `Denge sütunları`,
'sd03bff50f87f82d4': `Tireli karakter`,
'sd05a155fe09c2866': `Kullanırken çevrimiçi`,
'sd0864ea6cb6ef22e': `Topluluk`,
'sd10fdbe6caf9a998': `Satır Sonu`,
'sd121d3b959b7888d': `Hızı optimize edin`,
'sd1a78e667a1a139f': `Seçimi ekleme olarak işaretleme`,
'sd1cffad290ea5b3b': `Hepsini sakla`,
'sd1f10284eeb17b25': `Fiji`,
'sd1f44f1a8bc20e67': `E-posta`,
'sd1f81984eeb7c0e8': `Doldur`,
'sd29dc07235eea0f5': `Alıntı`,
'sd2addf69477cd4b4': `Paketi içe aktar`,
'sd2ed26defc646d47': `Arka Plan Filtresi`,
'sd2ef82b8ea877c6d': `Afrikanca`,
'sd319aae1401f1e19': `Sabit`,
'sd3a288c1094b8a63': `Sütun kuralı genişliği`,
'sd3c65ef5c380c046': `Giriş`,
'sd3dcb76f7b28adb8': `Letonca`,
'sd3eca1e0f4209f6e': `Hepsini düzeltin`,
'sd3f402df8619ddcd': `Hakkınızdaki bu bilgiler yeni belgelere otomatik olarak eklenir. Bunu meta veri
          düzenleyicisinde her belge için değiştirebilirsiniz.`,
'sd4368b12645d3c0f': `Bir portal ekleyin`,
'sd452cebf4a0313d1': `Kaynak düzenleme komutlarını göster`,
'sd48cc52117f4d68b': `İtalyan`,
'sd52660ee947ca58b': `Tablo sütunu ekleme`,
'sd588d17a1b25c220': `Metin taşması`,
'sd5be6f6d85fc0c9b': `Zulu`,
'sd5bf67958b08b4cf': `Yüksek eğitim.`,
'sd5cf95145e4d89ca': `Bu parçacığı kaldırın`,
'sd5fd9d11a92f5b1d': `Sol alt (y)`,
'sd60c9bbc51375635': `Düğme ekleme`,
'sd66c4767fa3dde28': `Vurgu rengi`,
'sd679c8b1bf8cc8a5': `Küçük kapaklar`,
'sd7086c4425c53c80': `Yazı tipi ailesi`,
'sd837f42ac7cbfb58': `Şekil (dış)`,
'sd88076d2994ee0fb': `Dışlama`,
'sd89a2e529b31ef43': `Geri Dön`,
'sd8a345e95668b73b': `Dikey, sağdan sola`,
'sd8ce9e57270b030d': `Yazı tipi esnemesi`,
'sd8ecf227c7c49331': `Matematiksel`,
'sd8f923198e0c5c6a': `Bitiş`,
'sd9c21e5f60d6bdd8': `Danimarka`,
'sd9ff8e2612e63d50': `Kenarlık kutusu boyutlandırma`,
'sda2d76b976502a8d': `Aç.`,
'sda344aacb837387e': `Konteyner içindeki konum`,
'sda5b6fa8b771f996': `Sola kayan`,
'sda9254d1f1228e1a': `Macarca`,
'sdb1595f5c742dfbb': `Giriş`,
'sdb711380a28fec75': `Liste ekleme (sıralı)`,
'sdb73788b3c975f16': `Otomatik`,
'sdbee7e0523a23a42': `Sağ alt (y)`,
'sdc48456f9a27ae02': `Jeneratör`,
'sdc70d81cf6c28533': `Gürcüce`,
'sdd1ff479d04ac140': `Kamu`,
'sdd2fc8919a9c3111': `Arka plan karışım modu`,
'sdd35b688281b6dea': `Japonca`,
'sddc49047f66a64ab': `Açıklama yapılmadı`,
'sdef34fe08bb28b09': `Çince (Basitleştirilmiş)`,
'sdf62e305e1594805': `Seçimi bir ruby ek açıklamasıyla işaretleyin`,
'sdf946172dfa0328f': `Üst simge`,
'sdf9bc5d9b7f3e3de': `Hizalama`,
'se036b53f145441cd': `Karışık İçerik`,
'se06f459fccdc3ce9': `Son metin satırını hizala`,
'se0a782a8be8e018b': `Norveççe`,
'se0cda6b80a1bb50f': `Slovakça`,
'se0f67eae944f8f94': `Sessiz`,
'se1312d6528f9a259': `Yoruba`,
'se16c5e66886fbc59': `Makale`,
'se1f5bb0386c88f96': `Seçili metnin rengini ayarlar`,
'se219da7b1e955c65': `Net biçimlendirme`,
'se25e4f2cb77b8be8': `WebWriter arayüzü ve yeni belgeler için dil`,
'se2796c5824ec8916': `İçerik görünürlüğü`,
'se308836a594808b6': `Singhalese`,
'se36c5b1baf5e0660': `Herhangi bir yerde`,
'se39c065efa467782': `Bask`,
'se3b4c857f91f80d7': `Klavye kısayolları`,
'se47baf2fd16b9d2b': `Şablon`,
'se48bd9e6c2a3109d': `Hesaplar`,
'se58467472725ad0c': `Görüntü çözünürlüğü`,
'se58f06c2b0583ff7': `Koordinatları seçin`,
'se5dc1e97fb743ade': `Aralık`,
'se619a501d1bfe6a5': `Şal`,
'se62385ac082368d2': `Seçimi bir alıntı kaynağı olarak işaretleyin`,
'se6297163cac9d276': `Kaynağı düzenle`,
'se633223a0b88625e': `Hücre yerleşimi`,
'se638417c560cfe5c': `İçeri girin`,
'se64f418b4e733b6c': `Bir çıkış ekleyin`,
'se79c0a3ac70d8fb3': `Asp. oranı (x)`,
'se79fae3ac710dc36': `Asp. oranı (y)`,
'se7fad370d8fb4cec': `Okunabilirliği optimize edin`,
'se8a94b4effa2033e': `Alfabetik`,
'se95d4e55ea186d9a': `Kaydırma çubuğu rengi`,
'se96d43a515b8451c': `Slovence`,
'se96fd76ba1b2975a': `Merkez`,
'se9ac05f36b004eb0': `Tanıtım turunu gizleyin. Turun tekrar gösterilmesi için devre dışı bırakın.`,
'se9b1fec72ffd8f48': `Yerel`,
'sea24bdcaa2bd2dec': `Zorunlu çıtçıt`,
'sea52df2b70a5c10d': `Yakut`,
'sea6e7291e27ec53f': `Meta veri düzenleyicisini açar`,
'sea896ed51ad33287': `Belirli bir stil mevcut değil`,
'seaaaeb09e3b4e78b': `Düzenleme komutları`,
'seabae79729c4b2ad': `E-postayı değiştir`,
'seaecc8267bad6234': `Ortaokul`,
'seaf97719986faf4f': `Boşluk`,
'seb19675a580f0628': `Sütundan kaçının`,
'seb4e52ef5ec7a7dc': `Renkler/Efektler`,
'seb8982ae8c3cdcc5': `Endonezce`,
'sebbced89e0db2894': `İlk temel hat`,
'sec02109a0dd2a6c8': `Renk vurgusu`,
'sec2557a35b702525': `Değişken`,
'sec2da4aa7a02b925': `İzlandaca`,
'sec30fbb20f102670': `Özet ekleyin`,
'sec8b0b6c729816b6': `Başlık Grubu`,
'seccd05955adb76bc': `Poster`,
'sed17285cd25d6389': `package.json dosyasının bulunduğu dizin`,
'sed318ec045c5144f': `Bitti`,
'sed713f1b916fb469': `Kenarlık aralığı (x)`,
'sed74a31b9172942c': `Kenarlık aralığı (y)`,
'sed86bd0deb2e5372': `Metni dönüştürün`,
'see2fcaedf9743ec6': `Konum`,
'seec6798afe90ffc8': `Yazdır`,
'sef00c258bc1ecf1e': `Bu keşfedilebilirde kaydedilmemiş değişiklikler var.`,
'sef23dd271edd4a8b': `Sol alt`,
'sef24caccbd4645ef': `Esnek büzüşme`,
'sef49aec68fd1dc66': `İsim`,
'sef73fe18e351eb35': `Anahtar Kelimeler`,
'sef75f458d77491af': `Seçenek Grubu`,
'sefcf950b3cc4fc3b': `Dil`,
'sf0c8e2b013e5ff18': `Bhutani`,
'sf0ca10f343249063': `İçindekiler`,
'sf0cab2483f66aa2e': `Özel`,
'sf0e261e04eda82ff': `Görünüş`,
'sf1045382c1fd9a85': `Tam baskı renkleri`,
'sf14c35392ec7bf10': `Bu özellik Firefox'ta kullanılamaz. Chrome veya Edge'de kullanılabilir.`,
'sf14f9d5f9f6ca342': `Artı daha hafif`,
'sf1868dc19e3917bb': `İspanyolca`,
'sf190149f9d8bbb2a': `Yazma modu`,
'sf1e79171c4856543': `Emin misiniz? Bu işlem geri alınamaz, tüm ayarlarınız silinecek ve sıfırlanacaktır.`,
'sf21c1f60c7515f44': `Seçimi örnek çıktı olarak işaretleyin`,
'sf21fb4f4b9e8911f': `Genişlik`,
'sf22a3737146ec910': `WebWriter SVG'yi doğrudan belgeye gömebilir.`,
'sf2514d5dc78b1654': `Widget ekle`,
'sf28903d4ca0ddcfc': `Bu hesabı kaldırın`,
'sf2ab37af0abc55ef': `Giriş turunu gizle`,
'sf2bdb0b4d7b9c039': `Bengalce`,
'sf2cbb5e519264e67': `Hem yatay hem de dikey olarak yeniden boyutlandırma`,
'sf2d5cbc2fe0ad65a': `Yapışkan`,
'sf2d96d0eb32cb81f': `Animasyon kompozisyonu`,
'sf2de3dbe2108637a': `Şekil oluşturma`,
'sf2e08a945e9194d4': `Welch`,
'sf34696c526e810b4': `Satır içi`,
'sf39736a666dbb038': `Parça ekleme`,
'sf3c4da68b08a2590': `Malgaşça`,
'sf471ec2496f904cc': `Değişiklikleri atın`,
'sf4849bc200e279ed': `Tablo başlığı`,
'sf486ca1fdbe08645': `Bir şekil ekleyin`,
'sf4b537d4cbd8f5fd': `Üst metin`,
'sf4e0e02a5277ef23': `Metin alanı ekleme`,
'sf4f067d41efd4b83': `Ölçek (y)`,
'sf4f3cbd41f002b46': `Ölçek (x)`,
'sf4fa67d41f05a008': `Ölçek (z)`,
'sf5197db2d5f2926a': `Döndür`,
'sf52d840949a980d1': str`
          ${0}
          kalıcı olarak silinecektir. Emin misiniz? 
        `,
'sf55d634dcc743595': `Hizmetler`,
'sf59c9081d106dd9c': `Seçimi değişken olarak işaretleme`,
'sf5e76f774beb33c2': `Inuktitut`,
'sf64a8229a8136552': `Belge silme`,
'sf65df67a03bebe4b': `Bu widget için gereklidir`,
'sf6673729c03ae999': `WebWriter'ı Sıfırla`,
'sf67571992e7dc88e': `Tam Dönem`,
'sf6b4934598f7ed10': `Seçime izin ver`,
'sf6e1665c7022a1f8': `Şifre`,
'sf79e0d78b56444f1': `Satır içi uç`,
'sf7a5f7a7c80c3082': `Her ikisi de`,
'sf7c0eba7c822e3d6': `Kalın`,
'sf86bd4d2982f3b74': `Seçimi kod olarak işaretleyin`,
'sf8e82313fa411494': `Seçimi bağlantı olarak işaretleme`,
'sf955eff73fb6b573': `Sırpça`,
'sf9929e2d356260c5': `Çarpma`,
'sf993bb199fefbe04': `Tümü`,
'sf9ecf969dd4b8164': `Her iki kenar`,
'sf9f2c719a04066ec': `Uygulama`,
'sfa49a5bb1a5d353e': `Özel erişim`,
'sfa59c7777e2a0eeb': `Veri listesi ekleme`,
'sfaa0a67db5c11f72': `İlk metin satırının girintisi`,
'sfb231a52211b133f': `Metin kaydırma yok`,
'sfb68cae41d749423': `Başlangıç`,
'sfb9b6edb0ed378c9': `Atıf Kaynağı`,
'sfbbab09dbe553571': `Vektör çizimi (SVG) ekleme`,
'sfc00292e778b67e2': `Metre`,
'sfc63e31ac7c956ed': `Seçiniz`,
'sfc815c9078bba30a': `QR Kodunu görüntü olarak indirin`,
'sfcdd8e672c75b713': `Adres`,
'sfcebd18506f1e535': `Akış`,
'sfd0cde85070d2eb2': `Flex`,
'sfd77270c3f54f664': `Çıktı`,
'sfdb1e4d90981a535': `Bu belgeyi paylaşın`,
'sfdeef3dccf409f81': `Bu anahtar sözcük widget'lar için gereklidir`,
'sfe6e758ad2603c1d': `Yüksek Lisans`,
'sfee1c12daf838935': `Renk yanığı`,
'sff303daee4dd9f7b': `Lingala`,
'sff3df0c2823ec6e4': `Verso`,
'sff99962304ac7d25': `Bir iletişim kutusu ekleyin`,
'sffa395f64ec6ac36': `Bulgarca`,
'sffdadf0a576fd802': `Yükseklik`,
'spaceKey': `Uzay`,
'tabKey': `⭾ Tab`,
'upKey': `↑ Yukarı`,
's0dc07f97c821463c': `Comment selection`,
's780099588362f80f': `Definition item`,
's105540b7756c0232': `Definition term`,
's98b1cb8fb62909ec': `Group`,
's151349210ac1d2d8': `Insert a group`,
's2739460e44320108': `Chinese (Traditional)`,
'sdc12d4d35420eeb7': `Comments`,
's74540c1b595a229c': `TeX Formula`,
'sc221faca1ecb4aee': `Anonymous`,
's0b7ae9543c001867': `Reply`,
's52fb1524cb25d7ab': `New thread`,
'scbf29ce484222325': ``,
    };
  